import client from './client';
import { Technology, TechnologyCreate, TechnologyUpdate, TechnologyListItem } from '../types/technology';

export interface TechnologyHierarchyNode {
  id: string;
  name: string;
  level: number;
  subtypes: TechnologyHierarchyNode[];
}

export interface TechnologyHierarchyResponse {
  technologies: TechnologyHierarchyNode[];
  statistics: {
    total_unique_technologies: number;
    technologies_by_level: {
      [key: string]: {
        total: number;
        terminal: number;
      };
    };
    total_terminal_technologies: number;
  };
}

export const searchTechnologies = async (query: string, limit: number = 20): Promise<TechnologyListItem[]> => {
  const response = await client.get('/api/v1/technologies/search', {
    params: { q: query, limit },
  });
  return response.data.results;
};

export const getTechnology = async (id: string): Promise<Technology> => {
  const response = await client.get(`/api/v1/technologies/${id}`);
  return response.data;
};

export const getTechnologyHierarchy = async (): Promise<TechnologyHierarchyResponse> => {
  const response = await client.get('/api/v1/technologies/hierarchy');
  return response.data;
};

export const createTechnology = async (data: TechnologyCreate): Promise<Technology> => {
  const response = await client.post('/api/v1/technologies/', data);
  return response.data;
};

export const updateTechnology = async (id: string, data: TechnologyUpdate): Promise<Technology> => {
  const response = await client.put(`/api/v1/technologies/${id}`, data);
  return response.data;
};

export const deleteTechnology = async (id: string): Promise<void> => {
  await client.delete(`/api/v1/technologies/${id}`);
};

export const enrichTechnology = async (
  id: string
): Promise<{ technology?: any; comparison?: Record<string, any>; error?: string }> => {
  const response = await client.post(`/api/v1/technologies/${id}/enrich`);
  return response.data;
};

export const addParentTechnology = async (technologyId: string, parentId: string): Promise<void> => {
  await client.post(`/api/v1/technologies/${technologyId}/parents/${parentId}`);
};

export const removeParentTechnology = async (technologyId: string, parentId: string): Promise<void> => {
  await client.delete(`/api/v1/technologies/${technologyId}/parents/${parentId}`);
};

export const addChildTechnology = async (technologyId: string, childId: string): Promise<void> => {
  await client.post(`/api/v1/technologies/${technologyId}/children/${childId}`);
};

export const removeChildTechnology = async (technologyId: string, childId: string): Promise<void> => {
  await client.delete(`/api/v1/technologies/${technologyId}/children/${childId}`);
};
